import { Injectable } from '@angular/core';
import { Http, Headers, URLSearchParams } from '@angular/http';
import { Configuration } from 'app/app.constants';
import { AuthenticationService } from './authentication.service';
import { Observable } from 'rxjs/Observable';
import { Grade } from 'app/agatextscreens/accounting/grade';

@Injectable()
export class GradeService {
  _gradeUrl = this._configuration.apiUrl + '/v2/grade';

  constructor(private _http: Http,
    private _configuration: Configuration,
    public _authService: AuthenticationService) { }

  getGrade(): Observable<any[]> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    return this._http.get(this._gradeUrl, { headers: h, search: s }).map(
      response => {
        let body = response.json();
        if (body['grades'] == null || !Array.isArray(body['grades']))
          return [];
        return body['grades'];
      }
    );
  }

  addGrade(grade: Grade) {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    return this._http.post(this._gradeUrl, grade, { headers: h, search: s }).map(response => response.json());
  }

  updateGrade(id: string, grade: Grade) {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('id', id);

    return this._http.put(this._gradeUrl, grade, { headers: h, search: s }).map(response => response.json());
  }

  removeGrade(id: string) {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('id', id);

    return this._http.delete(this._gradeUrl, { headers: h, search: s }).map(
      response => {
        let body = response.json();

        return Object.assign(body, { id: id });
      }
    );
  }

}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/shared/services/grade.service.ts